module.exports = __webpack_public_path__ + "media/images/badges/apple_badge-9ddbfec226a9ad4f220967ac503b0d35.svg";